<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-product-list" class="ag-grid-container">
    <statistics-cards :data="statisticalData"/>

    <div class="vx-card">
      <div v-show="showGridOne" class="grid-one">
        <grid-panel
            height="md"
            :column-defs="columnDefs"
            :url="() => this.productList"
            :auto-size="true"
            @rowClicked="view"
            show-deleted-toggle
            class="products-grid"
            @update:deleted="getProducts"
            title="Products"
            ref="productsGrid"
        >
          <template v-slot:bottom-left>
            <button-toggle
                class="mr-auto"
                v-model="toggleValue"
                :options="toggle"
            />
          </template>
          <template v-slot:bottom-right>
            <product-owner-radio-filter
                v-model="selectedProductOwnerId"
                :options="productOwnerOptions"
            />
          </template>

          <vs-dropdown-item v-if="componentAccess.canCreate.access">
            <span
                class="flex items-center"
                @click="$router.push({ name: 'products.create' })"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Create Product</span>
            </span>
          </vs-dropdown-item>

        </grid-panel>
      </div>

      <div v-show="!showGridOne" class="grid-two">

        <grid-panel
            :column-defs="sectionColumnDefs"
            :url="(params) => this.listProductsBySection(params)"
            @rowClicked="view"
            class="products-grid"
            :auto-group-column-def="autoGroupColumnDef"
            :gridOptions="productsBySectionGridOptions"
            title="Products"
            :api-params="sectionListParams"
            ref="productsSectionGrid"
        >
          <template v-slot:bottom-left>
            <button-toggle
                class="mr-auto"
                v-model="toggleValue"
                :options="toggle"
            />
          </template>
          <template v-slot:bottom-right>
            <product-owner-radio-filter
                v-model="selectedProductOwnerId"
                :options="productOwnerOptions"
            />
          </template>

          <vs-dropdown-item v-if="componentAccess.canCreate.access">
            <span
                class="flex items-center"
                @click="$router.push({ name: 'products.create' })"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Create Product</span>
            </span>
          </vs-dropdown-item>
        </grid-panel>
      </div>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import ButtonToggle from "../../components/extra-components/toggle/ButtonToggle";
import StatisticsCards from '@/components/statistics-cards/StatisticsCards.vue'
import ProductOwnerRadioFilter from "@/views/components/extra-components/ProductOwnerRadioFilter";

export default {
  components: {
    TGrid,
    GridPanel,
    ButtonToggle,
    StatisticsCards,
    ProductOwnerRadioFilter,
  },
  mixins: [CellMatchingMixin, CanAccessMixin],
  data () {
    return {
      componentAccess: {
        canCreate: {
          route: 'products.create',
          access: false,
        },
      },
      toggle: [
        {
          text: 'None',
          value: 0,
        },
        {
          text: 'By Section',
          value: 1,
        }
      ],
      toggleValue: 0,
      productList: [],
      searchQuery: '',
      showDeleted: false,
      productOwnerOptions: [],
      selectedProductOwnerId: null,
      productsBySectionGridOptions: {
        groupRowRendererParams: {
          suppressCount: false
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Product Code',
          field: 'ProductCode',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Product Description',
          field: 'ProductDescription',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Insurance Type',
          field: 'Type',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Wording',
          field: 'WordingCode',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Standard Clause',
          field: 'StandardClause',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Product Owner',
          field: 'ProductOwnerName',
          filter: 'agTextColumnFilter',
          width: 200,
        },
      ],
      sectionColumnDefs: [
        {
          headerName: 'Facility Reference',
          field: 'Facility_PK',
          width: 200,
          filter: 'agTextColumnFilter',
          rowGroup: true,
          valueGetter: (data) => {
            if (data.data) {
              return data.data.FacilityReference;
            }

            return data.value;
          },
        },
        {
          headerName: 'Section',
          field: 'Section',
          width: 180,
          filter: 'agTextColumnFilter',
          rowGroup: true,
        },
        {
          headerName: 'Product Code',
          field: 'ProductCode',
          filter: 'agTextColumnFilter',
          minWidth: 180,
        },
        {
          headerName: 'Product Description',
          field: 'ProductDescription',
          filter: 'agTextColumnFilter',
          minWidth: 350,
        },
        {
          headerName: 'Product Owner',
          field: 'ProductOwnerName',
          filter: 'agTextColumnFilter',
          minWidth: 200,
        },
        {
          headerName: 'Wording',
          field: 'WordingCode',
          filter: 'agTextColumnFilter',
          minWidth: 180,
        },
        {
          headerName: 'Insurance Type',
          field: 'Type',
          filter: 'agTextColumnFilter',
          minWidth: 250,
        },
      ],
      autoGroupColumnDef: {
        minWidth: 200,
        headerName: 'Group',
        cellRendererParams: {
          suppressCount: true,
        }
      },
      statisticalData: {
        products: {
          icon: 'file',
          label: 'Total Products',
          value: 0,
          tooltipText: 'Total Products',
        },
      },
    }
  },
  computed: {
    showGridOne() {
      return this.toggleValue === 0;
    },
    sectionListParams() {
      const params = {
        IsDeleted: this.showDeleted ? 1 : 0,
      };

      if (this.selectedProductOwnerId) {
        params.productOwnerId = this.selectedProductOwnerId;
      }

      return params;
    },
  },
  watch: {
    productList: {
      async handler(productList) {
        const { data } = await productList;
        let count = 0;

        if (data) {
          count = data.data.length;
        }

        this.statisticalData.products.value = count;
      },
      deep: true,
      immediate: true,
    },
    selectedProductOwnerId() {
      this.getProducts(this.showDeleted ? 1 : 0);
    },
  },
  created() {
    this.loadProductOwners();
    this.getProducts();
  },
  methods: {
    async loadProductOwners() {
      const { data } = await this.$api.productOwners.list();
      this.productOwnerOptions = data.data || [];
    },
    listProductsBySection(params = {}) {
      const nextParams = {
        IsDeleted: this.showDeleted ? 1 : 0,
        ...params,
      };

      if (this.selectedProductOwnerId) {
        nextParams.productOwnerId = this.selectedProductOwnerId;
      }

      return this.$api.products.listBySection({ params: nextParams });
    },
    getProducts(isDeleted = 0) {
      this.showDeleted = isDeleted;
      const params = { IsDeleted: isDeleted };

      if (this.selectedProductOwnerId) {
        params.productOwnerId = this.selectedProductOwnerId;
      }

      this.productList = this.$api.products.list({ params });
      if (this.$refs.productsGrid) {
        this.$refs.productsGrid.list(params);
      }
      // productsSectionGrid uses :api-params="sectionListParams" which automatically triggers reload via watcher

      return this.productList;
    },
    view({data}) {
      if (!data) {
        return;
      }

      this.$router.push({ name: 'products.view', params: { id: data.id }}).catch(() => {});
    }
  },
}

</script>

<style lang="scss">
</style>
